/* eslint-disable import/no-anonymous-default-export */
import { desArrow, infoIcn } from '../../assets'
import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import moment from 'moment';

export default function (props) {
    const [isOpen, setOpenDescriptor] = useState(false);
    const [greenlights, setGreenlights] = useState([]);

    useEffect(() => {
        const {
            greenlightVersionDocID
        } = props
        let docs = [];
        let greenlightVersionDocs = greenlightVersionDocID.split('$$');
        greenlightVersionDocs.map(x => {
            let greenlightVersion = x.split('@@');
            let _doc = { version: greenlightVersion[0], objectId: greenlightVersion[1], objectName: "", greenlightApprovedDate: "", greenlightApprovedDateStr: "", documentApprovedDate: "" }
            if (greenlightVersion.length > 2) {
                _doc.objectName = greenlightVersion[2]
            }
            if (greenlightVersion.length > 3 && greenlightVersion[3]) {

                _doc.greenlightApprovedDate = moment(greenlightVersion[3]).format("MM/DD/YYYY")
            }
            if (greenlightVersion.length > 4 && greenlightVersion[4] && greenlightVersion[4] !== "null") {

                _doc.greenlightApprovedDateStr = moment(greenlightVersion[4]).format("DD-MMM-YYYY")
            }
            if (greenlightVersion.length > 5 && greenlightVersion[5] && greenlightVersion[5] !== "null") {

                _doc.documentApprovedDate = moment(greenlightVersion[5]).format("DD-MMM-YYYY")
            }
            docs.push(_doc);
        })
        //docs = docs.sort((a, b) => parseFloat(b.version) - parseFloat(a.version));
        //docs = docs.sort((a, b) => moment(b.greenlightApprovedDate) - moment(a.greenlightApprovedDate));
        //docs = docs.sort((a, b) => moment(b.documentApprovedDate) - moment(a.documentApprovedDate));
        // if (window.location.origin === 'https://ims.jnj.com') {
        //     docs = docs.sort((a, b) => moment(b.greenlightApprovedDate) - moment(a.greenlightApprovedDate));
        // } else {
        //     docs = docs.sort((a, b) => moment(b.documentApprovedDate) - moment(a.documentApprovedDate));
        // }

        docs = docs.sort((a, b) => {
            // Primary sort: by firstName
            try {
                if (moment(b.documentApprovedDate) < moment(a.documentApprovedDate)) {
                    return -1;
                }
                if (moment(b.documentApprovedDate) > moment(a.documentApprovedDate)) {
                    return 1;
                }

                // Secondary sort: if firstNames are equal, sort by lastName
                if (moment(b.greenlightApprovedDateStr) < moment(a.greenlightApprovedDateStr)) {
                    return -1;
                }
                if (moment(b.greenlightApprovedDateStr) > moment(a.greenlightApprovedDateStr)) {
                    return 1;
                }
            } catch (error) {
                console.log("error", error)
            }


            return 0;
        });

        setGreenlights(docs);
    }, [])
    return (
        <div className="document-descriptor-wrapper">
            <div className="document-descriptor-header-wrapper" onClick={e => setOpenDescriptor(!isOpen)}>
                <img src={desArrow} alt='desArrow' className={isOpen ? "document-descriptor-img-rotate" : "document-descriptor-img"} onClick={e => setOpenDescriptor(!isOpen)} />
                <span> Greenlight Versions</span>
                <img src={infoIcn} alt='infoIcn' className="keyTakeaways-info-icn" title="Greenlight Version History" />
            </div>
            {isOpen &&
                <div className="document-descriptor-text-wrapper greenlight-table-wrapper">
                    <table cellPadding={5} cellSpacing={0} >
                        <thead>
                            <tr>
                                {/* <th>System Version Number</th> */}
                                <th>Object Name</th>
                                {/* <th>Version</th> */}
                                <th>Greenlight Approved Date
                                    <br />
                                    <span className="gen-ai-greenlight-version__approved-label-subtitle">(For Safety Reporting Only)</span>
                                </th>
                                {/* <th>Approved Date</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {greenlights.map(x => {
                                return (
                                    <tr>
                                        {/* <td><Link to={`/DocURL?ID=${x.objectId}&ref=Download&cs=RIMdocs&orderedBy=&orderedFor=&greenLight=true`} target="_blank">{x.version}</Link></td> */}
                                        <td><Link to={`/DocURL?ID=${x.objectId}&ref=Download&cs=RIMdocs&orderedBy=&orderedFor=&fileType=pdf&fileName=${x.objectName}&greenLight=true`} target="_blank">{x.objectName}</Link></td>
                                        {/* <td>{x.greenlightApprovedDate}</td> */}
                                        {/* <td>{x.version}</td> */}
                                        {/* {window.location.origin === 'https://ims.jnj.com' ? <td>{x.greenlightApprovedDate}</td> : <td>{x.greenlightApprovedDateStr}</td>} */}
                                        <td>{x.greenlightApprovedDateStr}</td>
                                        {/* <td>{x.documentApprovedDate}</td> */}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            }
        </div>
    )
}